import { WindowService } from '@app/shared/services';
import { filter, map, switchMap } from 'rxjs';
import { HeaderItem } from '../model/header.model';
import { NavMenuItem } from '../menu/models/nav-menu-item';
import { AdminItem } from '../modules/nav-item-admin/components/nav-item-admin-list/models';

export const mobileNavItemsFilter = (windowService: WindowService) =>
    switchMap((items: (AdminItem | NavMenuItem | HeaderItem)[]) =>
        windowService.xl$.pipe(
            filter((xl) => xl === false),
            map(() => items),
        ),
    );
